import './lpPartiallyCollapsible.scss';

function getCollapsibleHeight (collapsible, collapsibleStyle) {

	return (
		collapsible.offsetHeight
		- parseInt(collapsibleStyle.getPropertyValue('border-top-width'), 10)
		- parseInt(collapsibleStyle.getPropertyValue('border-bottom-width'), 10)
		- parseInt(collapsibleStyle.getPropertyValue('padding-top'), 10)
		- parseInt(collapsibleStyle.getPropertyValue('padding-bottom'), 10)
	);

}

// eslint-disable-next-line max-len
const FOCUSABLE_CONTENT_SELECTOR = 'a[href], button, input, select, textarea, details, summary, [tabindex]';

function setUnfocusableContent (collapsible) {

	collapsible.querySelectorAll(FOCUSABLE_CONTENT_SELECTOR).forEach((element) => {

		if (element.getAttribute('tabindex')) {

			element.setAttribute('data-tabindex', element.getAttribute('tabindex'));

		}
		if (element.getAttribute('href')) {

			element.setAttribute('data-href', element.getAttribute('href'));
			element.removeAttribute('href');

		}
		element.setAttribute('tabindex', '-1');

	});

}

function setFocusableContent (collapsible) {

	collapsible.querySelectorAll(FOCUSABLE_CONTENT_SELECTOR).forEach((element) => {

		if (element.getAttribute('data-tabindex')) {

			// if element had tabindex set previously, we want to restore it instead of removing it.
			element.setAttribute('tabindex', element.getAttribute('data-tabindex'));

		} else {

			element.removeAttribute('tabindex');

		}

		if (element.getAttribute('data-href')) {

			element.setAttribute('href', element.getAttribute('data-href'));

		}

	});

}

function handleCollapsibleClick ({
	collapsible, truncatedHeight, showMoreText, showLessText
}) {

	const isOpen = collapsible.classList.contains('collapsed');
	if (isOpen) {

		// eslint-disable-next-line no-param-reassign
		collapsible.style.height = '';
		collapsible.classList.remove('collapsed');
		this.textContent = showLessText;
		setFocusableContent(collapsible);

	} else {

		// eslint-disable-next-line no-param-reassign
		collapsible.style.height = `${truncatedHeight}px`;
		collapsible.classList.add('collapsed');
		this.textContent = showMoreText;
		setUnfocusableContent(collapsible);

	}

}

function lpPartiallyCollapsible (selector, options) {

	if (!selector || !selector.trim()) {

		return;

	}

	const elements = document.querySelectorAll(selector);

	if (elements.length === 0) {

		return;

	}

	const config = {
		minContainerHeight: 12,
		truncatedHeight: 11,
		showMoreText: '+ Show More',
		showLessText: '- Show Less',
		...options
	};
	// configs available below
	// go through each selector incase there are multiple
	elements.forEach((collapsible) => {

		// variables below in terms of line height of the container
		const collapsibleStyle = window.getComputedStyle(collapsible);
		const contentHeight = getCollapsibleHeight(collapsible, collapsibleStyle);
		const lineHeight = parseInt(collapsibleStyle.getPropertyValue('line-height'), 10);
		const minContainerHeight = lineHeight * config.minContainerHeight;

		// note this function does nothing if the below criteria is not met
		if (contentHeight >= minContainerHeight) {

			const truncatedHeight = lineHeight * config.truncatedHeight;
			const button = document.createElement('button');
			const { parentNode } = collapsible;

			// add the css classes we need
			collapsible.classList.add('partialCollapsible', 'collapsed');

			// onLoad set the height appropriately
			// eslint-disable-next-line no-param-reassign
			collapsible.style.height = `${truncatedHeight}px`;

			// add a button after the that for more and less
			button.type = 'button';
			button.className = 'calloutBtn calloutBtn--no-uppercase large alt2 partialCollapsibleButton showMoreLess';
			button.textContent = config.showMoreText;
			parentNode.insertBefore(button, collapsible.nextSibling);

			// note that we look for the button in the context of the parent
			const showMoreLess = parentNode.querySelector('.partialCollapsibleButton.showMoreLess');

			// handle the click event for that button
			showMoreLess.addEventListener('click', function (e) {

				e.preventDefault();

				handleCollapsibleClick.call(this, {
					collapsible,
					truncatedHeight,
					showMoreText: config.showMoreText,
					showLessText: config.showLessText
				});

			});

			setUnfocusableContent(collapsible);

		}

	});

}

export default lpPartiallyCollapsible;
